<div class="checkbox-container" [class.has-error]="hasError">
  <label [for]="id" class="app-checkbox layout-label">
    <div class="checkbox-wrapper">
      <input type="checkbox" [id]="id" [name]="name" [checked]="checked" [disabled]="disabled" (change)="toggleCheckbox()" class="cb-input" />
    </div>
    <div class="layout-label">
      @if (label) {
      {{ label }}
      }
      <ng-content></ng-content>
    </div>
  </label>
  
  <div *ngIf="hasError" class="error-message">
    {{ errorMsg }}
  </div>
</div>
